import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TELEMETRY_SEVERITY, } from '@proctoring/shared';
import { describeEvent } from '../describe-event.js';
/** Utility classes per severity, keyed by the shared `TelemetrySeverity` union. */
export const SEVERITY_CLASSES = {
    info: 'border-l-severity-info text-severity-info',
    warning: 'border-l-severity-warning text-severity-warning',
    critical: 'border-l-severity-critical text-severity-critical',
};
function defaultFormatTime(iso) {
    const at = new Date(iso);
    if (Number.isNaN(at.getTime()))
        return iso;
    return at.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    });
}
/**
 * The interviewer's live evidence feed.
 *
 * Each row carries its severity as a `data-severity` attribute as well as a colour: the
 * log is exportable evidence, so the severity has to be readable by something other than a
 * human eye on a colour display.
 */
export function TelemetryFeed({ events, formatTime = defaultFormatTime, emptyMessage = 'No events detected yet.', className, }) {
    return (_jsxs("section", { "aria-label": "Telemetry feed", className: `flex min-h-0 flex-col bg-session-panel text-session-text ${className ?? ''}`, children: [_jsxs("header", { className: "flex items-center justify-between border-b border-session-border px-3 py-2", children: [_jsx("h2", { className: "text-xs font-semibold tracking-wide text-session-muted uppercase", children: "Telemetry" }), _jsx("span", { className: "session-tabular-nums text-xs text-session-dim", children: events.length })] }), events.length === 0 ? (_jsx("p", { className: "px-3 py-4 text-sm text-session-dim", children: emptyMessage })) : (_jsx("ol", { className: "min-h-0 flex-1 overflow-y-auto", children: events.map((stored) => {
                    const description = describeEvent(stored.event);
                    const severity = TELEMETRY_SEVERITY[stored.event.type];
                    return (_jsxs("li", { "data-severity": severity, "data-event-type": stored.event.type, className: `border-b border-session-border border-l-2 px-3 py-2 ${SEVERITY_CLASSES[severity]}`, children: [_jsxs("div", { className: "flex items-baseline justify-between gap-2", children: [_jsx("span", { className: "text-sm font-medium", children: description.title }), _jsx("time", { dateTime: stored.event.timestamp, className: "session-tabular-nums shrink-0 text-xs text-session-dim", children: formatTime(stored.event.timestamp) })] }), _jsx("p", { className: "mt-0.5 text-sm text-session-muted", children: description.detail })] }, stored.id));
                }) }))] }));
}
//# sourceMappingURL=TelemetryFeed.js.map